import React, {FC, useCallback, useEffect, useRef, useState} from 'react';
import up from '../Assets/up.svg';
import '../App.css';
import {instance, sendMessage} from "../api/Chat";
import {useSocket} from "../Hooks/useSocket";
import {$userId} from "../Store/Store";
import Spinner from "./Spinner";

interface MessageInputInterface {
    message?: string
}

const MessageInput: FC<MessageInputInterface> = ({message}) => {
    const textArea: HTMLTextAreaElement | null = document.querySelector('textarea')
    const [messageText, setMessageText] = useState('')
    const [isSending, setIsSending] = useState(false);
    const [filesLoading, setFilesIsLoading] = useState(false)

    useEffect(() => {
        if (textArea) {
            textArea.style.height = 'auto';
            textArea.style.height = textArea.scrollHeight + 'px';
        }
        if (messageText.length > 0) {
            sendSocketMessage(JSON.stringify({
                action: 'TYPING',
                userId: $userId.getState(),
                data: true
            }));
        } else {
            sendSocketMessage(JSON.stringify({
                action: 'TYPING',
                userId: $userId.getState(),
                data: false
            }));
        }
    }, [messageText]);

    const handleChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
        setMessageText(e.target.value);
    };
    const handleSendMessage = async () => {
        if (messageText.length === 0 || isSending) return; // Не отправляем если сообщение пустое или уже идет отправка

        setIsSending(true); // Блокируем кнопку
        try {
            const res = await sendMessage(messageText);
            if (res) {
                sendSocketMessage(JSON.stringify({action: 'ECHO', data: 'okey'}));
                setMessageText('');
            }
        } catch (error) {
            console.error('Ошибка при отправке сообщения:', error);
        } finally {
            setIsSending(false);
        }
    };

    const {sendSocketMessage} = useSocket({sendMessageCallback: () => console.log('Message from server')});

    /**
     * Работа с файлами
     */
    const inputRef = useRef<HTMLInputElement>(null);
    const handleClick = () => {
        // Программный клик по инпуту (обходит ограничения iOS)
        inputRef.current?.click();
    };
    const handleFileChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
        const file = e.target.files?.[0];
        if (file) {
            const objectUrl = URL.createObjectURL(file);
            try {
                const result = await uploadImage(file);
                console.log('Ответ сервера:', result);
            } catch {
                alert('Ошибка при загрузке изображения, попробуйте позже');
            }
        }
        e.target.value = '';
    };

    const uploadImage = async (file: File) => {
        try {
            setFilesIsLoading(true)
            const formData = new FormData();
            formData.append('image', file); // имя поля зависит от backend

            const response = await instance.post('/upload', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            });
            sendSocketMessage(JSON.stringify({action: 'ECHO', data: 'okey'}));
            return response.data;
        } catch (error) {
            console.error('Ошибка загрузки файла:', error);
            alert('Ошибка загрузки файла')
        } finally {
            setFilesIsLoading(false)
        }
    };
    /**
     * Работа с файлами END
     */

    return (
        <div className="input-container glass-effect" style={{borderRadius: 0}}>
            <textarea onChange={handleChange} className="textarea"
                      placeholder={'Сообщение'} value={messageText} rows={1}/>
            {
                messageText.length === 0 && (
                    <div>
                        <input
                            ref={inputRef}
                            type="file"
                            accept="image/*"
                            onChange={handleFileChange}
                            style={{display: 'none'}}
                        />
                        {
                            filesLoading ? (<div className={'send-button'} style={{right: 5}}><Spinner/></div>) : (
                                <div className={'clip-button'} onClick={handleClick}>
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        viewBox="0 0 512 512"
                                        width="32px"
                                        height="32px"
                                        color='#74757A'
                                    >
                                        <path
                                            fill="currentColor"
                                            d="M153.456 472a136 136 0 0 1-96.167-232.166l196.6-196.6l22.631 22.623l-196.6 196.6A104 104 0 0 0 227 409.539l207.912-207.917A72 72 0 0 0 333.088 99.8L125.171 307.716a40 40 0 1 0 56.568 56.568l179.634-179.632L384 207.279L204.367 386.911a72 72 0 1 1-101.823-101.822L310.461 77.172a104 104 0 1 1 147.078 147.077L249.622 432.166A135.1 135.1 0 0 1 153.456 472"
                                        ></path>
                                    </svg>
                                </div>
                            )
                        }
                    </div>
                )
            }
            {messageText.length > 0 && (
                <button className="send-button"
                        disabled={isSending}
                        onClick={handleSendMessage}
                >
                    {isSending ? (
                        <Spinner/>) : (
                        <img src={up} className="send-icon" width={18} alt="logo"/>)}
                </button>
            )
            }
        </div>
    )
};

export default MessageInput;
